module.exports = __webpack_public_path__ + "static/media/beranda-women.e7f8bf34.png";